<template>
  <v-dialog :value="visible" @input="$emit('close')" max-width="500">
    <v-card>
      <v-card-title class="text-h6 grey--text text--darken-3"> CPF já cadastrado </v-card-title>

      <v-card-text class="text-body-1">
        <p class="text-h6 mb-3">
          Este CPF pertence a {{ artigo }} {{ tipoTexto }} cadastrado{{ concordancia }} no sistema.
        </p>
        <p class="text-h6 mb-3"><strong>Nome:</strong> {{ nome }}</p>
        <p class="text-body-1">Por favor, utilize um CPF diferente.</p>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn color="primary" @click="$emit('close')"> OK </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CpfDuplicadoModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      required: true,
      validator(value) {
        return ["aluno", "professor", "usuario"].includes(value);
      },
    },
    nome: {
      type: String,
      default: "",
    },
    contexto: {
      type: String,
      required: true,
      validator(value) {
        return ["aluno", "professor", "usuario"].includes(value);
      },
    },
  },
  computed: {
    tipoTexto() {
      const textos = {
        aluno: "aluno",
        professor: "professor",
        usuario: "usuário",
      };
      return textos[this.tipo] || "";
    },
    artigo() {
      return "um";
    },
    concordancia() {
      return "";
    },
    contextoTexto() {
      const textos = {
        aluno: "aluno",
        professor: "professor",
        usuario: "usuário",
      };
      return textos[this.contexto] || "";
    },
    artigoContexto() {
      return "um";
    },
    mostrarMensagemNaoPode() {
      return this.tipo !== this.contexto;
    },
  },
};
</script>
